import type { FaireProductEntity } from "../../entity_types/product";

export const p_mwu7h8446v: FaireProductEntity = {
  token: "p_mwu7h8446v",
  type: "product",
  name: "Hawaiian Sparkling Pineapple Citrus Soda, 12-Pack",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/21d46b620bc4c3eebca49474e78f441dde924df33937d51539ffb6aabbb44730.jpeg",
  galleryImageUrls: [],
  priceDollars: 51.16,
  description:
    "Everyday Supply Co brings you a tropical getaway in a can with our Hawaiian Sparkling Pineapple Citrus Soda. Each sip bursts with the vibrant flavors of ripe pineapple and citrus, making it the perfect thirst quencher. Ideal for any occasion, this 12-pack is a must-have for soda lovers seeking a unique, carbonated delight. Enjoy the trusted quality of Everyday Supply Co with every bubbly sip.",
  tags: [],
  msrpDollars: 102.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:11.305Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
